<template>
  <a-drawer
    width="600"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="小区名称" prop="community">
        <a-input v-model="form.community" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="选择位置">
        <AmapSearch ref="map" height="500px" @getInfo="getAddress" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { communityInfo, communityAdd, communityEdit } from '@/api/pages/region'
    import AmapSearch from '@/components/AmapSearch'

export default {
  name: 'CreateForm',
    components: { AmapSearch },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      open: false,
      resArr: null,
      level: 1,
      // 表单
      form: {
        community: '',
        deviceAreaCityId: 0,
        deviceAreaId: 0,
        deviceAreaProvinceId: 0,
        id: 0,
        lat: 0,
        log: 0,
        remark: ''
      },
      rules: {
        community: [{ required: true, message: '小区名称不能为空', trigger: 'blur' }],
        log: [{ required: true, message: '请选择位置', trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.form = {
        community: '',
        deviceAreaCityId: 0,
        deviceAreaId: 0,
        deviceAreaProvinceId: 0,
        id: 0,
        lat: 0,
        log: 0,
        remark: ''
      }
    },
    getAddress(detail) {
      console.log(detail)
      this.form.lat = detail.latitude
      this.form.log = detail.longitude
      this.$forceUpdate()
    },
     /** 新增按钮操作 */
    handleAdd (form) {
      this.reset()
      this.open = true
      this.form.deviceAreaProvinceId = form.deviceAreaProvinceId
      this.form.deviceAreaCityId = form.deviceAreaCityId
      this.form.deviceAreaId = form.deviceAreaId

      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      const configId = row ? row.id : ids
      communityInfo({ id: configId }).then(response => {
        this.form = response.data
        this.$nextTick(() => {
          this.$refs.map.mapInit(response.data.log, response.data.lat)
        })
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form)
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id) {
            communityEdit(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            communityAdd(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
